import { Link } from 'react-router-dom';
import { Building2, Truck, Car, Bike, PackageCheck, Landmark, HardHat, ArrowUpRight } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';
import CTABand from '@/components/CTABand';
import { Reveal, Stagger, StaggerItem } from '@/components/Reveal';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [Building2, Truck, Car, Bike, PackageCheck, Landmark, HardHat];

export default function Solutions() {
  const { t, isRTL } = useLanguage();
  const items = t('solutions.items');
  return (
    <div className="pt-28" data-testid="solutions-page">
      <section className="mx-auto max-w-7xl px-5 pt-8 lg:px-8">
        <SectionHeading eyebrow="solutions.eyebrow" title="solutions.title" sub="solutions.sub" align="center" />
        <Stagger className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" gap={0.08}>
          {items.map((s, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <StaggerItem key={s.t}>
                <div className="card-hover flex h-full flex-col rounded-2xl border border-brand-line bg-white p-7" data-testid={`solution-card-${i}`}>
                  <span className={`grid h-12 w-12 place-items-center rounded-2xl border ${['bg-brand-blue/8 border-brand-blue/15 text-brand-blue', 'bg-brand-sky/10 border-brand-sky/20 text-brand-sky', 'bg-brand-teal/10 border-brand-teal/20 text-brand-teal', 'bg-brand-violet/10 border-brand-violet/20 text-brand-violet'][i % 4]}`}>
                    <Icon className="h-5.5 w-5.5 h-6 w-6" />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-bold text-brand-ink">{s.t}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-steel">{s.d}</p>
                  <Link to={s.link || '/contact'} data-testid={`solution-cta-${i}`} className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-brand-blue transition-transform hover:-translate-y-0.5">
                    {t('ctaBand.cta2')} <ArrowUpRight className={`h-3.5 w-3.5 ${isRTL ? 'rotate-[-90deg]' : ''}`} />
                  </Link>
                </div>
              </StaggerItem>
            );
          })}
          <StaggerItem>
            <div className="flex h-full flex-col items-start justify-center rounded-2xl bg-gradient-to-br from-brand-blue to-brand-sky p-7" data-testid="solutions-cta-card">
              <h3 className="font-display text-xl font-extrabold text-white">{t('ctaBand.title')}</h3>
              <p className="mt-2 text-sm leading-relaxed text-sky-100">{t('ctaBand.sub')}</p>
              <Link to="/contact" data-testid="solutions-cta-main" className="mt-5 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-brand-blue">{t('ctaBand.cta1')}</Link>
            </div>
          </StaggerItem>
        </Stagger>
      </section>
      <CTABand />
    </div>
  );
}
